module.exports = __webpack_public_path__ + "img/horizontal-rule.dd15dd2a.svg";